import store from '@/_shared/store';
import { useNotification } from './useNotification';

const VIP_ONLY_ROUTES = [
  'all_users',
  'user_form',
  'login_history',
];

export const useRoleIdentifier = {
  mixins: [useNotification],
  methods: {
    userHasPermission(item = {}) {
      if (!item.onlyVipRoles) {
        return true;
      }
      return !!this.checkVipRole();
    },
    checkVipRole(currentRole = null) {
      if (!currentRole && store.state.user.role) {
        currentRole = store.state.user.role.name;
      }
      const vipRoles = ["администратор", "владелец", "руководитель"];
      return !!vipRoles.includes(currentRole);
    },
    redirectIfNotVip() {
      const isVipRoute = VIP_ONLY_ROUTES.includes(this.$route.name);
      if (!this.checkVipRole() && isVipRoute) {
        this.showErrorNotification("Недостаточно прав для посещения страницы");
        this.$router.push("/");
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/_shared/mixins/useRoleIdentifier.js